import React from "react"

import { Link } from "gatsby"
import { Container, Breadcrumb } from "react-bootstrap"

import "./breadcrumb.scss"
import renderElement from "../../utils/renderElement"

const BreadcrumbComponent = props => {
  return (
    <section className={`breadcrumb-section ${props.style}`}>
      <Breadcrumb>
        <Container className="d-flex">
          {props?.pages &&
            props.pages.map((page, index) => (
              <li className="breadcrumb-item" key={index}>
                <Link to={`${page.link}`}>
                  <span
                    dangerouslySetInnerHTML={renderElement(page.name)}
                  ></span>
                </Link>
              </li>
            ))}
          <li
            className="breadcrumb-item active"
            dangerouslySetInnerHTML={renderElement(props.currentPage.name)}
          ></li>
        </Container>
      </Breadcrumb>
    </section>
  )
}

export default BreadcrumbComponent
